// extracted by mini-css-extract-plugin
var _1 = "UserMultiValuedListMoreItem-moduleUserMultiValuedListMoreItem__ob9Du MultiValuedListMoreItem-moduleMultiValuedListMoreItem__SSTEE";
export { _1 as "UserMultiValuedListMoreItem" }
